import { useState } from 'react';

interface ListingImageProps {
  thumbnailUrl: string | null;
  title: string;
  /** Fixed box so missing/hotlink-blocked photos never collapse the layout. */
  className?: string;
}

function Placeholder() {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center bg-gray-100 text-gray-400 gap-1">
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25z"
        />
      </svg>
      <span className="text-[10px] font-medium">No photo</span>
    </div>
  );
}

/**
 * Provider card thumbnail (hotlinked, CHO-705 does not re-host). Ricardo
 * bot-blocks detail pages so many listings have no image at all, and
 * hotlinked thumbs can 404 — both fall back to a fixed-size placeholder so
 * the row/card never reflows.
 */
export default function ListingImage({ thumbnailUrl, title, className = 'w-28 h-20' }: ListingImageProps) {
  const [failed, setFailed] = useState(false);
  if (!thumbnailUrl || failed) {
    return (
      <div className={`${className} rounded-md overflow-hidden border border-gray-200 shrink-0`}>
        <Placeholder />
      </div>
    );
  }
  return (
    <div className={`${className} rounded-md overflow-hidden border border-gray-200 bg-gray-100 shrink-0`}>
      <img
        src={thumbnailUrl}
        alt={title}
        loading="lazy"
        referrerPolicy="no-referrer"
        className="w-full h-full object-cover"
        onError={() => setFailed(true)}
      />
    </div>
  );
}
